// Copyright (c) 2020 Deere & Company

import CscUserRoutingInfo from '../../shared/state/csc-user-routing-info';
import actions from '../../../shared/actions-list';
import {getDefaultState} from '../state';

const updateCscUserRoutingInfo = (state, action) =>
CscUserRoutingInfo.update(state, {
    $set: action.data
});

export default (state = getDefaultState().cscUserRoutingInfo, action) => {

    const actionTypes = {
        [actions.UPDATE_CSC_USER_ROUTING_INFO]: updateCscUserRoutingInfo

    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/user/shared/reducers/csc-user-routing-info.js